import React from 'react';
import { useTranslation } from 'react-i18next';
import { BarChartCard, BarDataPoint } from '../../../../ui/BarChartCard';
import { getColorForIndex } from '../../../../../utils/chartColors';
import { HydratedBarChartBlock } from '../../../../../services/admin/cloudAgentTypes';
import { BlockSourceNote } from './BlockSourceNote';

/** barChart → BarChartCard. */
export const BarChartBlock: React.FC<{ block: HydratedBarChartBlock }> = ({ block }) => {
  const { t } = useTranslation();
  const data: BarDataPoint[] = block.data.bars.map((b, i) => ({
    name: b.label,
    value: b.value,
    color: b.color || getColorForIndex(i),
  }));
  return (
    // Own horizontal scroller: many bars must never widen the page on mobile.
    <div className="overflow-x-auto">
      <BarChartCard title={block.title ?? t('cloudAgent.blockTitles.barChart')} data={data} />
      <BlockSourceNote source={block.source} />
    </div>
  );
};
